import { useMemo } from 'react'
import { t } from '@lingui/core/macro'
import { useLingui } from '@lingui/react'

/**
 * 动态获取皮肤相关翻译的 Hook
 * 当语言切换时，翻译会自动更新
 */
export const useSkinTranslations = () => {
  const { i18n } = useLingui() // 这会在语言变化时触发重新渲染

  const exteriorEnum = useMemo(
    () => ({
      0: t`Default`,
      1: t`Battle-Scarred`,
      2: t`Well-Worn`,
      3: t`Field-Tested`,
      4: t`Minimal Wear`,
      5: t`Factory New`,
    }),
    [i18n.locale],
  ) // 依赖当前语言

  const rarityEnum = useMemo(
    () => ({
      0: t`Default`,
      1: t`Consumer grade`,
      2: t`Industrial grade`,
      3: t`Mil-spec grade`,
      4: t`Restricted`,
      5: t`Classified`,
      6: t`Covert`,
      7: t`Rare`,
      8: t`Extraodinary`,
      9: t`Immortal`,
      10: t`Contraband`,
      11: t`Exceptional`,
      12: t`Exotic`,
      13: t`Distinguished`,
      14: t`Base grade`,
      15: t`Distinguished agents`,
      16: t`Exceptional agents`,
      17: t`Extraordinary agents`,
      18: t`Master agents`,
    }),
    [i18n.locale],
  )

  const phaseEnum = useMemo(
    () => ({
      0: t`Phase 1`,
      1: t`Phase 2`,
      2: t`Phase 3`,
      3: t`Phase 4`,
      4: t`Ruby`,
      5: t`Sapphire`,
      6: t`Black Pearl`,
      7: t`Emerald`,
    }),
    [i18n.locale],
  )

  const specialtyEnum = useMemo(
    () => ({
      2: t`StatTrak™`,
      3: t`★`,
      4: t`★ StatTrak™`,
    }),
    [i18n.locale],
  )

  return {
    exteriorEnum,
    rarityEnum,
    phaseEnum,
    specialtyEnum,
  }
}
